export default __webpack_public_path__ + "static/DSJ_SB-5d4e99278d65e6c45c74a118f01f8dfc.jpeg";